<template>
    <div class="posters">
        <canvas id="myqrcode" ref="myqrcode" width="200" height="200" style="display:none"></canvas>
        <canvas id="postCanvas" ref="postCanvas" width="812" height="1280" style="display:none"></canvas>
        <img v-if="resultSrc" :src="resultSrc" id="resultImg">
        <el-button type="primary" @click="downloadImg" class="download">下载海报</el-button>
    </div>
</template>
<script>
import QRCode from 'qrcode';
import imgsrc from '@/assets/images/index/shareBg.png';
import { mapState } from 'vuex';
export default {
    name: 'Posters',
    props: {},
    data() {
        return {
            visible: false,
            resultSrc: '',
            qrSrc: '',
            error: ''
        };
    },
    computed: {
        ...mapState({
            profile: state => state.user.profile
        })
    },
    mounted() {
        this.startDraw();
    },
    methods: {
        startDraw() {
            this.creatQrCode()
                .then(res => {
                    return new Promise(resolve => {
                        let content = document.getElementById('postCanvas').getContext('2d');
                        let canvas = document.getElementById('postCanvas');
                        let dpr = 1; // this.getPixelRatio(content);
                        let W = canvas.width;
                        let H = canvas.height;
                        canvas.width = W * dpr;
                        canvas.height = H * dpr;
                        canvas.style.width = W + 'px';
                        canvas.style.height = H + 'px';
                        content.beginPath();
                        content.clearRect(0, 0, canvas.width, canvas.height);
                        this.roundRect(content, 0, 0, canvas.width, canvas.height, 20 * dpr);
                        resolve({content, canvas, dpr});
                    });
                })
                .then(({content, canvas, dpr}) => {
                    return this.drawBg({content, canvas, dpr});
                })
                .then(({content, canvas, dpr}) => {
                    return this.drawQr({content, canvas, dpr});
                })
                .then(({canvas}) => {
                    this.resultSrc = canvas.toDataURL();
                });
        },
        // 动态生成二维码
        creatQrCode() {
            let _this = this;
            const urlLink = `${feConfig.studentApi.base}/fdhtH5.html#/recomPostors?teacherId=${this.profile.id}`;
            return new Promise((resolve, reject) => {
                QRCode.toDataURL(document.getElementById('myqrcode'), urlLink, {
                    width: 200,
                    height: 200,
                    errorCorrectionLevel: 'H',
                    quality: 0.8,
                    margin: 0,
                    color: {
                        dark: '#ffffff',
                        light: '#000000'
                    }
                }, function(error, url) {
                    // console.log(url)
                    _this.qrSrc = url;
                    _this.error = error;
                    resolve();
                });
            });
        },
        drawBg({content, canvas, dpr}) {
            return new Promise(resolve => {
                let bg = new Image();
                console.log(imgsrc);
                bg.src = imgsrc;
                let that = this;
                bg.onload = function() {
                    content.drawImage(bg, 0, 0, canvas.width, canvas.height);
                    resolve({content, canvas, dpr});
                };
            });
        },
        drawQr({content, canvas, dpr}) {
            return new Promise(resolve => {
                let qrImg = new Image();
                qrImg.src = this.qrSrc;
                console.log(qrImg.src);
                qrImg.onload = function() {
                    content.drawImage(qrImg, 528 * dpr, 1044 * dpr, 200 * dpr, 200 * dpr);
                    resolve({canvas});
                };
            });
        },
        roundRect(ctx, x, y, w, h, r) {
            if (w < 2 * r) r = w / 2;
            if (h < 2 * r) r = h / 2;
            // ctx.beginPath();
            ctx.moveTo(x + r, y);
            ctx.arcTo(x + w, y, x + w, y + h, r);
            ctx.arcTo(x + w, y + h, x, y + h, r);
            ctx.arcTo(x, y + h, x, y, r);
            ctx.arcTo(x, y, x + w, y, r);
            ctx.closePath();
            ctx.clip();
        },
        downloadImg() {
            const imgUrl = document.getElementById('resultImg').src;
            // 如果浏览器支持msSaveOrOpenBlob方法（也就是使用IE浏览器的时候），那么调用该方法去下载图片
            if (window.navigator.msSaveOrOpenBlob) {
                var bstr = atob(imgUrl.split(',')[1]);
                var n = bstr.length;
                var u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                var blob = new Blob([u8arr]);
                window.navigator.msSaveOrOpenBlob(blob, 'chart-download' + '.' + 'png');
            } else {
                // 这里就按照chrome等新版浏览器来处理
                const a = document.createElement('a');
                a.href = imgUrl;
                a.setAttribute('download', '我的专属海报');
                a.click();
            }
        }
    }
};
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
.posters {
    text-align: center;

    #resultImg {
        width: 300px;
    }

    .download {
        display: block;
        margin: 20px auto 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/index/components/common/posters.vue